import * as stationUploadFileAction from '../actions/stationUploadFileAction'

const initialState = {
    result: [],
    error: undefined,
    status: 0
};

const StationUploadFile = (state = initialState, action) => {
    switch (action.type) {
        case stationUploadFileAction.STATIONUPLOADFILE_LIST_REQUEST:
            return ({
                ...initialState,
                status: 1
            });

        case stationUploadFileAction.STATIONUPLOADFILE_LIST_SUCCESS:
            return ({
                ...action.result,
                error: undefined,
                status: 2
            });

        case stationUploadFileAction.STATIONUPLOADFILE_LIST_FAILURE:
            return ({
                ...initialState,
                error: action.error,
                status: 3
            });

        case stationUploadFileAction.STATIONUPLOADFILE_ADD_REQUEST:
            return ({
                ...state,
                status: 1
            });

        case stationUploadFileAction.STATIONUPLOADFILE_ADD_SUCCESS:
            return ({
                ...action.result,
                error: undefined,
                status: 2
            });

        case stationUploadFileAction.STATIONUPLOADFILE_ADD_FAILURE:
            return ({
                ...state,
                error: action.error,
                status: 3
            });

        case stationUploadFileAction.STATIONUPLOADFILE_DELETE_REQUEST:
            return ({
                ...state,
                status: 1
            });

        case stationUploadFileAction.STATIONUPLOADFILE_DELETE_SUCCESS:
            return ({
                ...action.result,
                error: undefined,
                status: 2
            });

        case stationUploadFileAction.STATIONUPLOADFILE_DELETE_FAILURE:
            return ({
                ...state,
                error: action.error,
                status: 3
            });
            
        default:
            return (state);
    };
}

export default StationUploadFile;
